/* eslint-disable react/require-default-props */
/**
 * The external dependencies
 */

/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

import {
  GridLegacy,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Box,
} from '@mui/material';
import ChangeFilter from '../ChangeFilter/ChangeFilter';

type SectionProps = {
  Title: string;
  headerExtraInfo?: React.ReactNode;
  Controls?: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  search: boolean;
  allPossibleStatus?: string[];
  filteredStatuses?: string[];
  onSearch?: (search: string, statuses?: string[]) => void;
};

const Section = observer(
  ({
    Title,
    headerExtraInfo,
    children,
    Controls,
    onClick,
    search,
    onSearch,
    allPossibleStatus,
    filteredStatuses,
    ...props
  }: SectionProps) => {
    const { t } = useTranslation();

    const [searchString, setSearchString] = useState('');

    return (
      <Card
        elevation={4}
        css={css`
          padding: 24px;
          background-color: white;
          position: relative;
          border-radius: 20px;
          box-shadow: none;
          @media (max-width: 810px) {
            max-width: 100%;
          }
        `}
        onClick={onClick}
        {...props}
      >
        <CardHeader
          css={css`
            display: flex;
            padding-bottom: 16px;
            text-transform: uppercase;
            margin-right: auto;
            padding-top: 0px;
            padding-left: 0px;

            max-width: 100%;
          `}
          action={headerExtraInfo ?? null}
          title={Title}
          titleTypographyProps={{
            variant: 'h4',
            component: 'h4',
          }}
        />

        <CardContent sx={{ padding: '0px !important' }}>
          <GridLegacy container>
            <GridLegacy
              item
              css={css`
                position: absolute;
                top: 24px;
                right: 24px;
              `}
            >
              {Controls}
              <Box sx={{ display: 'flex' }}>
                {search && onSearch && (
                  <TextField
                    onChange={e => {
                      setSearchString(e.target.value);
                      onSearch(e.target.value);
                    }}
                    label={t('buttons.search')}
                    id="outlined-basic"
                    variant="standard"
                  />
                )}
                {onSearch && (
                  <ChangeFilter
                    possibleStatusList={allPossibleStatus}
                    filteredStatuses={filteredStatuses || []}
                    setFilteredStatuses={statuses =>
                      onSearch(searchString, statuses)
                    }
                  />
                )}
              </Box>
            </GridLegacy>

            <GridLegacy
              item
              css={css`
                width: 100%;
              `}
            >
              {children}
            </GridLegacy>
          </GridLegacy>
        </CardContent>
      </Card>
    );
  },
);

export default Section;
